/**
 * Composable for handling image URL generation
 */

export function useImageHelpers() {
  const getSolarScheduleImage = (movie, size) => {
    if (!movie?.solarPortraitImages) return "";
    const sizeData = movie.solarPortraitImages[size];
    if (!sizeData) return "";

    // If it's an object with numbered keys, return the first image
    if (typeof sizeData === "object" && sizeData["1"]) {
      return sizeData["1"];
    }

    // If it's already a string, return it
    return sizeData;
  };

  return {
    getSolarScheduleImage,
  };
}
